export const ALL_TRANSLATION_KEYS = [
    'bdo-libranza-title-loan-simulator',
    'bdo-libranza-description-loan-simulator',
    'bdo-libranza-button-simulate',
    'bdo-libranza-label-select-company',
    'bdo-libranza-placeholder-search-company',
    'bdo-libranza-no-options-companies',
    'bdo-libranza-helper-company',
    'bdo-libranza-label-amount',
    'bdo-libranza-placeholder-amount',
    'bdo-libranza-helper-amount',
    'bdo-libranza-error-minimum',
    'bdo-libranza-error-maximum',
    'bdo-libranza-label-term',
    'bdo-libranza-placeholder-term',
    'bdo-libranza-no-options-terms',
    'bdo-libranza-helper-term',
    'bdo-libranza-checkbox-include-insurance',
    'bdo-libranza-tooltip-insurance',
    'bdo-libranza-title',
    'bdo-libranza-title-simulation-result',
    'bdo-libranza-description-simulation-result',
    'bdo-libranza-label-your-simulation',
    'bdo-libranza-label-term-result',
    'bdo-libranza-label-rate-result',
    'bdo-libranza-label-loan-amount',
    'bdo-libranza-label-payment-without-insurance',
    'bdo-libranza-label-protected-insurance',
    'bdo-libranza-label-monthly-payment',
    'bdo-libranza-button-request-loan',
    'bdo-libranza-button-request-advice'
  ];
  